<template>
  <Datepicker
    :value="value"
    @input="onInput"
    input-class="form-control"
    :wrapper-class="wrapperClass"
    calendar-class="datepicker-calendar"
    :highlighted="{ days: [0] }"
    :format="formatDisplay"
    :clear-button="true"
    :inline="inline"
    :full-month-name="fullMonthName"
    :day-cell-content="dayCellContent"
    @changedMonth="$emit('changedMonth', $event)"
  />
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    Datepicker
  },
  props: {
    value: {
      type: String,
      required: true
    },
    position: {
      type: String,
      required: false,
      default: 'left'
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullMonthName: {
      type: Boolean,
      required: false,
      default: false,
    },
    dayCellContent: {
      type: Function,
      required: false,
    },
  },
  computed: {
    wrapperClass() {
      const classNames = ['datepicker']

      if (this.position === 'right') {
        classNames.push('datepicker-right')
      }

      if (this.inline) {
        classNames.push('datepicker-inline')
      }

      return classNames
    }
  },
  methods: {
    formatDisplay(val) {
      return moment(val).format('YYYY/M/D')
    },
    formatValue(val) {
      const m = moment(val)
      return m.isValid() ? m.format('YYYY-MM-DD') : ''
    },
    onInput(val) {
      this.$emit('input', this.formatValue(val))
    }
  }
}
</script>
